export default __webpack_public_path__ + "static/media/cover-img.cf70f40c.jpg";